// Shared subscription types to avoid conflicts across components
export const TIER_CODES = ["demo", "starter", "core_plus", "founding_member"] as const;
export type SubscriptionTier = (typeof TIER_CODES)[number];
export const isTier = (x: string): x is SubscriptionTier =>
  (TIER_CODES as readonly string[]).includes(x);

// UI tier for v32 components (founding_member maps to core_plus for display)
export const UI_TIER_CODES = ["demo", "starter", "core_plus"] as const;
export type V32UITier = (typeof UI_TIER_CODES)[number];

// Map backend subscription tier to UI tier
export function mapToUITier(tier: SubscriptionTier): V32UITier {
  if (tier === 'founding_member' || tier === 'core_plus') return 'core_plus';
  return tier as V32UITier;
}

export type MealPlanState =
  | "empty"
  | "generating"
  | "ready"
  | "success"
  | "error";

export interface UsageStats {
  plansUsed: number;
  plansLimit: number;
  swapsUsed: number;
  swapsLimit: number;
  daysUntilReset: number;
}

export interface SwipePattern {
  recipeId: string;
  title: string;
  cuisine: string;
  difficulty: string;
  prepTime: number;
  calories: number;
  tags: string[];
  action: "liked" | "skipped" | "saved" | "maybe";
  timestamp: number;
  context: string;
}

export interface Recipe {
  id: string;
  title: string;
  imageUrl: string;
  prepTime: number;
  calories: number;
  difficulty: "easy" | "medium" | "hard";
  tags: string[];
  ingredients: string[];
  description: string;
  cuisine: string;
}
